import { mapGetters } from 'vuex';
import RegExp from '@/utils/regExp.js';
import { successMessage, errorMessage } from '@/utils/message.js';

export default {
  data() {
    return {
      timer: null,
      active: false,
      smsCodeShowText: '获取验证码',
      smsCodeShowCount: 60,
      formForMobile: {
        type: 2,
        smsCode: '',
        mobile: '',
        verifyCode: ''
      },
      formForAccount: {
        type: 2,
        clientid: 'PC', // pc端默认写PC
        password: '',
        username: '',
        verifyCode: '',
        token: ''
      },
      rulesForAccount: {
        username: [
          { required: true, message: '请输入手机号码', trigger: 'blur'},
          { pattern: RegExp.phone, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur'},
          { pattern: RegExp.passWord, message: '请输入6～16位的数字或字母', trigger: 'blur'}
        ],
        verifyCode: [
          { required: true, message: '请输入图片验证码', trigger: 'blur'}
        ]
      },
      rulesForMobile: {
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur'},
          { pattern: RegExp.phone, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        verifyCode: [
          { required: true, message: '请输入图片验证码', trigger: 'blur'}
        ],
        smsCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur'}
        ]
      }
    };
  },
  created() {
    this.updateCaptchaImage();
    // console.log(this.formForMobile.mobile, 'formForMobile.mobile');
  },
  mounted() {
    // console.log(1);
    this.formForMobile.username = '';
    this.formForMobile.password = '';
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    };
  },
  watch: {
    'formForMobile.type': function () {
      const type = this.formForMobile.type;
      this.resetFormRules();
      this.formForMobile.type = type;
    },
    'formForAccount.type': function () {
      const type = this.formForAccount.type;
      this.resetFormRules();
      this.formForAccount.type = type;
    }
  },
  computed: {
    ...mapGetters([
      'captchaImageSrc',
      'ticket'
    ])
  },
  methods: {
    // 清除表单项
    onReset() {
      this.formForMobile = {
        type: 2,
        smsCode: '',
        mobile: '',
        verifyCode: ''
      };
      this.formForAccount = {
        type: 2,
        clientid: 'PC', // pc端默认写PC
        password: '',
        username: '',
        verifyCode: '',
        token: ''
      };
    },
    // 清空表单校验
    resetFormRules() {
      if (this.$refs['formForAccount']) {
        this.$refs['formForAccount'].resetFields();
      };
      if (this.$refs['formForMobile']) {
        this.$refs['formForMobile'].resetFields();
      };
    },
    // 切换账号密码登录
    selectTabName() {
      this.updateCaptchaImage();
      this.resetFormRules();
      this.active = !this.active;
    },
    // 更新图片验证码
    updateCaptchaImage() {
      this.$store.commit('SET_CAPTCHA_IMAGE', {data: {imgsIo: '', ticket: ''}});
      this.$store.dispatch('getCodeImage').then(() => {
      }, error => {
        if (error && error.reason) {
          errorMessage(error.reason);
        } else {
          errorMessage('更新验证码失败，请重试');
        }
      });
    },
    // 手机验证码倒计时
    countDownOfSmsCode() {
      let _this = this;
      if (this.smsCodeShowCount >= 1) {
        _this.timer = setInterval(function() {
          _this.smsCodeShowCount--;
          _this.smsCodeShowText = _this.smsCodeShowCount + 'S';
          if (_this.smsCodeShowCount <= 0) {
            _this.smsCodeShowText = '重新获取';
            _this.smsCodeShowCount = 60;
            clearInterval(_this.timer);
          }
        }, 1000);
      }
    },
    // 获取手机验证码
    getSmsCode() {
      const form = {mobile: this.formForMobile.mobile, ticket: this.ticket, verifyCode: this.formForMobile.verifyCode, type: this.formForMobile.type};
      if (!form.mobile) {
        errorMessage('请先输入手机号');
        return;
      }
      if (!RegExp.phone.test(form.mobile)) {
        errorMessage('请输入正确的手机号');
        return;
      }
      if (!form.verifyCode) {
        errorMessage('请先输入图片验证码');
        return;
      }
      if (form.verifyCode && form.verifyCode.length !== 4) {
        errorMessage('请输入正确的图片验证码');
        return;
      }
      if (this.smsCodeShowCount === 60) {
        this.smsCodeShowText = '发送中...';
        this.$store.dispatch('getSmsCodeSign', form).then(res => {
          if (res.code === '0') {
            this.countDownOfSmsCode();
            successMessage('验证码发送成功');
          }
        }, error => {
          this.updateCaptchaImage();
          this.smsCodeShowText = '获取验证码';
          this.smsCodeShowCount = 60;
          if (error && error.reason) {
            errorMessage(error.reason);
          } else {
            errorMessage('获取验证码失败，请重试');
          }
        });
      }
    },
    // 手机验证码登录
    loginSystemByMobile() {
      delete this.formForMobile.verifyCode;
      this.$store.dispatch('loginSystemByMobile', this.formForMobile).then((res) => {
        if (res.code === '0') {
          this.$emit('loginSuccess');
          successMessage('登录成功');
          if (this.$route.path === '/signin' || this.$route.path === '/register/second-step' || this.$route.path === '/register/third-step') {
            this.$router.push('/index');
          }
        }
      }, error => {
        this.updateCaptchaImage();
        if (error && error.reason) {
          errorMessage(error.reason);
        } else {
          errorMessage('登录失败，请重试');
        }
      });
    },
    // 账号密码登录
    loginByPassword() {
      this.formForAccount.token = this.ticket;
      this.$store.dispatch('loginSystem', this.formForAccount).then((res) => {
        if (res.code === '0') {
          this.$emit('loginSuccess');
          successMessage('登录成功');
          console.log(this.$route.path, 'this.$route.path');
          if (this.$route.path === '/signin' || this.$route.path === '/register/second-step' || this.$route.path === '/register/third-step') {
            this.$router.push('/index');
          }
        }
      }, error => {
        this.updateCaptchaImage();
        if (error && error.reason) {
          errorMessage(error.reason);
        } else {
          errorMessage('登录失败，请重试');
        }
      });
    },
    // 登录
    login() {
      // console.log(this.formForAccount, 'formForAccount.username');
      if (this.active) {
        this.$refs['formForMobile'].validate(valid => {
          if (valid) {
            this.loginSystemByMobile();
          }
        });
      } else {
        this.$refs['formForAccount'].validate(valid => {
          if (valid) {
            this.loginByPassword();
          }
        });
      }
    },
    // 忘记密码
    forgetPassword() {
      this.$emit('toRegister');
      this.$router.push('/forget-password/authenticate');
    },
    // 注册
    toRegister() {
      this.$router.push('/register/first-step');
      this.$emit('toRegister');
    }
  }
};
